import { iDataset } from "@/services";

const state = {
  cloudUse: false,

  cloudId: 0,

  datasetId: 0,
  datasetName: "",
  datasetSize: 0,
  datasetCount: 0,

  lastUploaderId: 0,

  currentStatus: "", // UPLOAD, SYNC, UPLOAD_FAIL, SYNC_FAIL, AVAILABLE

  treeItems: [],
  treeTimeout: null,
};

const mutations = {
  /** CLOUD 사용 여부 설정 */
  setCloudUse: (state, data) => {
    state.cloudUse = data;
  },
  /** CLOUD ID 설정 */
  setCloudId: (state, data) => {
    state.cloudId = data;
  },
  /** 현재 데이터셋 ID 설정 */
  setDatasetId: (state, data) => {
    state.datasetId = data;
  },
  /** 햔제 데이터셋 설정 */
  setCurrentDataset: (state, data) => {
    state.datasetName = data.datasetName;
  },
  /** 업로드 ID 설정 */
  setLastUploaderId: (state, data) => {
    state.lastUploaderId = data;
  },
  /** 현재 상태(업로드, 동기화, 기본) 설정 */
  setCurrentStatus: (state, data) => {
    state.currentStatus = data;
  },
  /** 트리 리스트 설정 */
  setTreeItems: (state, data) => {
    state.treeItems = data;
  },
  /** 트리 interval 설정 */
  setTreeInterval: (state, data) => {
    state.treeInterval = data;
  },
  /** 전체 초기화 */
  clearAll: (state) => {
    state.cloudUse = false;
    state.cloudId = 0;
    state.datasetId = 0;
    state.datasetName = "";
    state.datasetSize = 0;
    state.datasetCount = 0;
    state.lastUploaderId = 0;
    state.currentStatus = "";
    state.treeItems = [];
    state.treeInterval = null;
  },
};

const actions = {
  /** 데이터셋 처음 시작 */
  async datasetInit({ state, commit }, projectId) {
    const res = await iDataset.getRootDatasets(projectId);

    if (!res.data.length) return;

    res.data.forEach((obj) => {
      if (obj.storageType === "S3") {
        commit("setCloudUse", true);
        commit("setCloudId", parseInt(obj.id));
      }
    });

    commit("setDatasetId", state.cloudId);
    return;
  },

  /** 루트 폴더 생성 (S3) */
  async createRootDataset({ commit, dispatch }, payload) {
    const res = await iDataset.createRootDataset(payload);
    if (!res) {
      console.log("createRootDataset error");
      return;
    }

    commit("setLastUploaderId", res.data.lastUploaderId);
    commit("setDatasetId", res.data.id);
    commit("setCurrentStatus", res.data.status);
    await dispatch("datasetInit", payload.projectId);
  },

  /** 트리 조회 */
  async getTreeItems({ state, commit }) {
    if (state.cloudId === 0) return;

    const res = await iDataset.getDatasetsOfTree(state.cloudId);
    commit("setTreeItems", [res.data]);
  },

  async setTreeTimeout({ state, dispatch }) {
    state.treeTimeout = setTimeout(() => {
      dispatch("getTreeItems");
      dispatch("setTreeTimeout");
    }, 1000);
  },

  async clearTreeTimeout({ state }) {
    clearTimeout(state.treeTimeout);
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
